<template>
  <div class="active-global-container">
    <FreeModal />
    <CampaignModal />
    <PostSuccessModal />
    <BindCardModal />
  </div>
</template>

<script>
import RunEvents from "@/layouts/dialog-config/index";
import FreeModal from "./FreeModal.vue";
import CampaignModal from "./CampaignModal.vue";
import PostSuccessModal from "./PostSuccessModal.vue";
import BindCardModal from "./bindCardModal.vue";

export default {
  name: "GlobalModals",
  components: {
    FreeModal,
    CampaignModal,
    PostSuccessModal,
    BindCardModal,
  },
  watch: {
    "$route.path": {
      immediate: true,
      handler() {
        if (
          this.$route.query.isNew == 1 ||
          // localStorage.getItem("showGuide") == "1"
          (this.userGuide &&
            this.userGuide.sales_progress == 0 &&
            this.$route.path == "/sales/salesReps/campaign") ||
          (this.userGuide.hr_progress == 0 &&
            this.$route.path == "/hr/recruiter/campaign") ||
          (this.userGuide.sales_progress < 4 &&
            this.$route.path == "/sales/salesReps/createCampaign" &&
            this.$route.query.linkedin_id == "new") ||
          (this.userGuide.hr_progress < 4 &&
            this.$route.path == "/hr/recruiter/createCampaign" &&
            this.$route.query.linkedin_id == "new")
        ) {
          return;
        }
        RunEvents(this.$route);
      },
    },
  },
};
</script>

<style scoped></style>
